import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';

import Content from '../common/template/content';
import { getAccessList } from './cameraActions';
import { CAMERA_TYPES, normalizeCameraUrl, isValidCameraInput } from './cameraConfig';
import './camera.css';

class CameraAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customIp: '',
      loading: true,
    };

    this.handleCustomIpChange = this.handleCustomIpChange.bind(this);
    this.handleCustomKeyDown = this.handleCustomKeyDown.bind(this);
  }

  componentWillMount() {
    this.props.getAccessList(this.props.type).finally(() => {
      this.setState({ loading: false });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.type !== this.props.type) {
      this.setState({
        customIp: '',
        loading: true,
      });
      this.props.getAccessList(nextProps.type).finally(() => {
        this.setState({ loading: false });
      });
    }
  }

  getConfig() {
    return CAMERA_TYPES[this.props.type] || CAMERA_TYPES.deteccao;
  }

  handleCustomIpChange(event) {
    this.setState({ customIp: event.target.value });
  }

  handleOpenCustom(event) {
    const { customIp } = this.state;

    if (!isValidCameraInput(customIp)) {
      event.preventDefault();
      toastr.error('Endereço inválido', 'Informe um IP ou URL válido, por exemplo: 192.168.1.244');
    }
  }

  handleCustomKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleOpenCustom(event);
    }
  }

  renderDefaultCard(camera) {
    const url = normalizeCameraUrl(camera.endereco);
    const controladorLabel = camera.numero_controlador
      ? `Ctrl ${String(camera.numero_controlador).padStart(2, '0')}`
      : 'Controlador';

    return (
      <div className="camera-access-card" key={camera.id}>
        <div className="camera-access-card-icon">
          <i className="fa fa-video" />
        </div>
        <div className="camera-access-card-body">
          <h5>{camera.descricao}</h5>
          <span className="camera-access-card-ip">{camera.endereco}</span>
          <p className="camera-access-card-meta">
            {controladorLabel}
            {camera.controlador_endereco ? ` — ${camera.controlador_endereco}` : ''}
          </p>
          <p className="camera-access-card-url">{url}</p>
        </div>
        <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-primary camera-access-card-btn">
          <i className="fa fa-external-link-alt" />
          Abrir
        </a>
      </div>
    );
  }

  render() {
    const config = this.getConfig();
    const { customIp, loading } = this.state;
    const cameras = this.props.accessList || [];
    const customUrl = isValidCameraInput(customIp) ? normalizeCameraUrl(customIp) : '#';

    return (
      <Content>
        <div className="camera-access-page">
          <div className="simple-cad-premium-container">
            <div className="simple-cad-premium-card camera-access-hero">
              <div className="simple-cad-premium-header">
                <h4>
                  <i className={`fa fa-${config.icon}`} />
                  {config.title}
                </h4>
                <p>{config.subtitle}</p>
              </div>

              <div className="simple-cad-premium-body camera-access-custom-block">
                <div className="camera-access-section-title">
                  <h5>
                    <i className="fa fa-plug" />
                    IP personalizado
                  </h5>
                  <span>Informe outro endereço e abra a câmera em nova aba.</span>
                </div>

                <div className="camera-access-custom-form">
                  <div className="camera-access-input-wrap">
                    <label htmlFor="camera-custom-ip">Endereço da câmera</label>
                    <input
                      id="camera-custom-ip"
                      type="text"
                      className="form-control"
                      placeholder="Ex: 192.168.1.244 ou http://192.168.1.244/login.jsp"
                      value={customIp}
                      onChange={this.handleCustomIpChange}
                      onKeyDown={this.handleCustomKeyDown}
                    />
                  </div>
                  <a
                    href={customUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success camera-access-open-btn"
                    onClick={this.handleOpenCustom}
                  >
                    <i className="fa fa-external-link-alt" />
                    Abrir câmera
                  </a>
                </div>
              </div>
            </div>

            <div className="simple-cad-premium-card camera-access-defaults-card">
              <div className="camera-access-defaults-header">
                <div className="camera-access-section-title">
                  <h5>
                    <i className="fa fa-th-large" />
                    Câmeras cadastradas
                  </h5>
                  <span>
                    {loading ? 'Carregando câmeras...' : `${cameras.length} endereço(s) ativo(s) no sistema.`}
                  </span>
                </div>
              </div>

              {loading ? (
                <div className="camera-access-empty">
                  <i className="fa fa-spinner fa-spin" />
                  <span>Carregando câmeras...</span>
                </div>
              ) : cameras.length === 0 ? (
                <div className="camera-access-empty">
                  <i className="fa fa-video-slash" />
                  <span>Nenhuma câmera cadastrada para este tipo.</span>
                  <Link to="/cadcamera" className="btn btn-default btn-sm">
                    Ir para cadastro de câmeras
                  </Link>
                </div>
              ) : (
                <div className="camera-access-grid">{cameras.map(camera => this.renderDefaultCard(camera))}</div>
              )}
            </div>
          </div>
        </div>
      </Content>
    );
  }
}

const mapStateToProps = state => ({
  accessList: state.cameraCad.accessList,
});

const mapDispatchToProps = dispatch => bindActionCreators({ getAccessList }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CameraAccess);
